import React, { useContext, useEffect, useState } from 'react'
import theme from '@ifca-root/react-component/src/assets/theme'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import { ExcelInput } from '@ifca-root/react-component/src/components/Input/ExcelUploadInput'
import {
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { useLocation, useParams } from 'react-router-dom'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { useHistory } from 'react-router'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2'
import {
  useCreateBillItemExcelMutation,
  useGetBillItemImportCheckingValidationLazyQuery,
  useImportBillItemExcelMutation,
} from '../../../generated/graphql'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { ItemExcelInput } from '@account-root/procurement-react/src/containers/GeneralSettingModule/Item/ItemImportExcelDialog'

export const BillItemImportExcelValidation = (props: any) => {
  const { module } = props
  let location = useLocation()
  const passedData: any = location?.state
  const fileName = passedData.fileTitle
  let history = useHistory()
  const { BatchID }: any = useParams()
  let user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [validatedData, setValidatedData] = useState<any>({
    ErrorData: [],
    ValidData: [],
  })
  const [openUpload, setOpenUpload] = useState(null)
  const [openDialog, setOpenDialog] = useState(null)
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  let validationPath = `/account-receivable/general-setting/bill-items/import-bill-item-validation/${BatchID}`
  let backPath = `/account-receivable/general-setting/bill-items`
  let itemLabel = 'Bill Item'
  let moduleLabel = 'Account Receivable'

  const [
    loadData,
    {
      loading: BillItemImportCheckingValidationLoading,
      error: getItemImportCheckingValidationError,
      data: { getBillItemImportCheckingValidation } = {
        getBillItemImportCheckingValidation: [],
      },
    },
  ] = useGetBillItemImportCheckingValidationLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getBillItemImportCheckingValidation }) => {
      if (getBillItemImportCheckingValidation?.Data?.length > 0) {
        let ErrorData: any = []
        let ValidData: any = []

        getBillItemImportCheckingValidation?.Data?.map(x => {
          if (x['err_status'] === true)
            ErrorData.push({
              Name: x['Name'],
              Description: x['Description'],
              TaxSchemeName: x['TaxSchemeName'],
              MasterCOACode: x['MasterCOACode'],
              EInvoice: x['EInvoice'],
              MSICCode: x['MSICCode'],
              ClassificationCode: x['ClassificationCode'],
              RowNo: x['RowNo'],
              ErrorList: x['err_remarks'],
            })
          else
            ValidData.push({
              Name: x['Name'],
              Description: x['Description'],
              TaxSchemeName: x['TaxSchemeName'],
              MasterCOACode: x['MasterCOACode'],
              EInvoice: x['EInvoice'],
              MSICCode: x['MSICCode'],
              ClassificationCode: x['ClassificationCode'],
              RowNo: x['RowNo'],
              ErrorList: x['err_remarks'],
            })
        })

        setValidatedData({
          ErrorData: [...validatedData.ErrorData, ...ErrorData],
          ValidData: [...validatedData.ValidData, ...ValidData],
        })
      }
    },
  })

  const [
    ImportItemExcel,
    { loading: ImportBillItemExcelLoading, error: createError },
  ] = useImportBillItemExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
    },
    onCompleted: data => {
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
      setValidatedData({ ErrorData: [], ValidData: [] })
      loadData({
        variables: {
          BatchID: BatchID ?? passedData?.BatchID,
          take: 30,
          skip: 0,
        },
      })
      history.push({
        pathname: validationPath,
        state: {
          BatchID: BatchID,
          fileTitle: fileTitle,
        },
      })
    },
  })

  const [
    ConfirmUpload,
    { loading: CreateBillItemExcelLoading, error: confirmUploadError },
  ] = useCreateBillItemExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
      history.push({
        pathname: backPath,
      })
      setSnackBarMsg(SystemMsgs.createNewRecord)
      setOpenSnackBar(true)
    },
  })

  useEffect(() => {
    loadData({
      variables: {
        BatchID: BatchID ?? passedData?.BatchID,
        take: 30,
        skip: 0,
      },
    })
  }, [])

  const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    //setOpenSnackBar,
    snackBarMessage,
    setSnackBarMessage,
    currentData,
    setCurrentData,
    onDownloadTemplate,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
  } = useExcelUploadVersion2()

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  const onImport = data => {
    ImportItemExcel({
      variables: {
        BatchID: BatchID,
        BillItemExcelImportInput: data?.map(x => {
          return {
            BatchID: BatchID,
            Name: x?.Name === '' ? null : `${x?.Name}`,
            Description: x?.Description === '' ? null : `${x?.Description}`,
            TaxSchemeName:
              x?.TaxSchemeName === '' ? null : `${x?.TaxSchemeName}`,
            MasterCOACode:
              x?.GLAccountCode === '' ? null : `${x?.GLAccountCode}`,
            EInvoice:
              x?.['e-Invoice'] === 'true' ||
              x?.['e-Invoice'] === 'True' ||
              x?.['e-Invoice'] === 'TRUE' ||
              x?.['e-Invoice'] === 'Yes'
                ? true
                : x?.['e-Invoice'] === 'false' ||
                  x?.['e-Invoice'] === 'False' ||
                  x?.['e-Invoice'] === 'FALSE' ||
                  x?.['e-Invoice'] === 'No' ||
                  x?.['e-Invoice'] === ''
                ? false
                : x?.['e-Invoice'],
            MSICCode: x?.MSICCode === '' ? null : `${x?.MSICCode}`,
            ClassificationCode:
              x?.ClassificationCode === '' ? null : `${x?.ClassificationCode}`,
            RowNo: x?.rowNo,
          }
        }),
      },
    })
  }

  const onConfirm = () => {
    ConfirmUpload({ variables: { BatchID } })
  }

  return (
    <>
      {BillItemImportCheckingValidationLoading && <Loading />}
      {ImportBillItemExcelLoading && <Loading />}
      {CreateBillItemExcelLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => history.push(backPath)}
        smTitle={moduleLabel}
        title={user?.accountName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: itemLabel, current: true },
        ]}
      />

      <DynamicSubHeader
        style={{
          marginTop: '-2px',
        }}
        title={`${itemLabel} Excel Upload`}
        rightText={<span className="c-orange">Validation</span>}
      />
      <List className="search-header fixed-search-header with-dynamic">
        <ListItem>
          <ListItemText
            primary={
              <>
                <span className="xsTitle flex-space">{fileName}</span>
              </>
            }
          />
        </ListItem>
      </List>

      <ContentWrapper
        style={{ marginTop: isDesktop ? '140px' : '75px' }}
        float
        footer
      >
        <InfiniteScroll
          dataLength={
            validatedData?.ErrorData?.length + validatedData?.ValidData?.length
          } //This is important field to render the next data
          next={() => {
            loadData({
              variables: {
                BatchID: BatchID ?? passedData?.BatchID,
                skip:
                  validatedData?.ErrorData?.length +
                  validatedData?.ValidData?.length,
                take: 30,
              },
            })
          }}
          hasMore={true}
          className=""
          style={{ padding: '8px 6px' }}
          loader={
            BillItemImportCheckingValidationLoading && (
              <div style={{ textAlign: 'center' }}>
                {' '}
                <CircularProgress />{' '}
              </div>
            )
          }
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>-</b>
            </p>
          }
        >
          {/* Problem List */}
          {validatedData.ErrorData?.length > 0 && (
            <>
              <List style={{ marginBottom: '-13px' }}>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        <span
                          className="xsTitle"
                          style={{ marginLeft: '-9px' }}
                        >
                          Problem{' '}
                          {
                            <>
                              (
                              <span className="highlight-text">
                                {
                                  getBillItemImportCheckingValidation?.ProblemCount
                                }
                              </span>
                              )
                            </>
                          }
                        </span>
                      </>
                    }
                  />
                </ListItem>
              </List>
              <List className="core-list">
                {validatedData.ErrorData?.map((el, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      // style={{
                      //   textAlign: 'right',
                      //   marginLeft: '5px',
                      // }}
                      primary={
                        <>
                          <div style={{ width: '100%' }}>
                            <div>
                              <span className="xsTitle flex-space ">
                                Name:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Name}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                Description:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Description}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                TaxSchemeName:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.TaxSchemeName}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                MasterCOACode:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.MasterCOACode}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                e-Invoice:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.EInvoice === true ? 'True' : 'False'}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                MSICCode:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.MSICCode}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                ClassificationCode:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.ClassificationCode}{' '}
                              </span>
                            </div>
                          </div>
                        </>
                      }
                      secondary={
                        <>
                          <div>
                            <div
                              className="xsTitle text-noflow"
                              style={{ color: 'red' }}
                            >
                              {' '}
                              Row No: {el.RowNo}
                            </div>
                            <div
                              className="xsTitle text-noflow"
                              style={{ color: 'red' }}
                            >
                              {el.ErrorList}
                            </div>
                          </div>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}

          {/* Validation List */}
          {validatedData.ValidData?.length > 0 && (
            <>
              <List style={{ marginBottom: '-13px' }}>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        <span
                          className="xsTitle"
                          style={{ marginLeft: '-9px' }}
                        >
                          Validated{' '}
                          {
                            <>
                              (
                              <span className="highlight-text">
                                {
                                  getBillItemImportCheckingValidation?.ValidCount
                                }
                              </span>
                              )
                            </>
                          }
                        </span>
                      </>
                    }
                  />
                </ListItem>
              </List>
              <List className="core-list">
                {validatedData.ValidData?.map((el, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      // style={{
                      //   textAlign: 'right',
                      //   marginLeft: '5px',
                      // }}
                      primary={
                        <>
                          <div style={{ width: '100%' }}>
                            <div>
                              <span className="xsTitle flex-space ">
                                Name:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Name}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                Description:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Description}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                TaxSchemeName:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.TaxSchemeName}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                MasterCOACode:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.MasterCOACode}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                e-Invoice:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.EInvoice === true ? 'True' : 'False'}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                MSICCode:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.MSICCode}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                ClassificationCode:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.ClassificationCode}{' '}
                              </span>
                            </div>
                          </div>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </InfiniteScroll>
      </ContentWrapper>

      <Footer
        options={
          validatedData.ErrorData?.length === 0 &&
          validatedData.ValidData?.length > 0
            ? [
                {
                  onClick: () => {
                    setOpenDialog(true)
                  },
                  name: 'Confirm Upload',
                  color: 'primary',
                },
              ]
            : [
                {
                  name: 'Re-upload',
                  color: 'primary',
                  onClick: () => {
                    setOpenUpload(true)
                  },
                },
              ]
        }
      />

      <ItemExcelInput
        showDupErrors={false}
        duplicateItems={duplicateItems}
        errorDia={duplicateErrorDia}
        setErrorDia={setErrorDialog}
        openUpload={openUpload}
        setOpenUpload={setOpenUpload}
        upload={fileTitle}
        template={currentData}
        setTemplate={setCurrentData}
        setUpload={setFileTitle}
        resetFileUpload={resetFileUpload}
        showFooter={false}
        reUpload={true}
        onUploadTemplate={() => {
          onImport(currentData)
          console.log('currentData', currentData)
          setOpenUpload(false)
        }}
        onSelectFile={(e: any) => {
          onSelectFile({ event: e })
        }}
        onDownloadTemplate={onDownloadTemplate}
        snackBarProps={{
          openSnackBar: openSnackBar,
          snackBarMessage: 'test',
          setOpenSnackBar: setOpenSnackBar,
          onClickButton: () => {
            setOpenSnackBar(false)
          },
        }}
      />

      <CommonDialog
        fullWidth={true}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false)
        }}
        sections={{
          header: {
            dynamic: (
              <div className="">
                <div className="dialog-dynamic-content">
                  <span
                    className="title c-orange flex-space"
                    style={{
                      fontSize: '13px',
                      fontWeight: 'bold',
                    }}
                  >
                    Upload Confirmation
                  </span>
                </div>
              </div>
            ),
          },
          body: () => (
            <div>
              <span>{'Are you sure to upload?'}</span>
            </div>
          ),

          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    setOpenDialog(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    onConfirm()
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
